import { render, staticRenderFns } from "./sensitive-word.vue?vue&type=template&id=5ada53c1"
import script from "./sensitive-word.vue?vue&type=script&lang=ts"
export * from "./sensitive-word.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports